import chroma from "chroma-js";

const lightColorPalette = [
  "#E3E3FF",
  "#FCFADE",
  "#DFF2FD",
  "#FFEEE2",
  "#E2FCE6",
  "#FFDBDB",
];

const darkColorPalette = [
  "#5EBD3E",
  "#E3AC14",
  "#F78200",
  "#E23838",
  "#973999",
  "#009CDF",
];

export function getColor(numClusters: number, cluster: number, light: boolean) {
  const colorPalette = light ? lightColorPalette : darkColorPalette;
  if (numClusters <= 6) {
    return colorPalette[cluster];
  } else {
    const palette = chroma.scale(colorPalette).colors(numClusters);
    return palette[cluster];
  }
}
